import BackIcon from "@frontend/lyng/assets/icons/24/outline/chevron-left.svg?react";
import { useNavigate, useOutletContext, useParams } from "react-router";
import { useFeatureFlag } from "../../providers/FeatureFlags";
import { LoadingBounce } from "@frontend/lyng/loading";
import { DefaultGenerics, StreamChat } from "stream-chat";
import { useTranslate } from "@tolgee/react";
import { Button } from "@frontend/lyng/button";
import { useChatContext } from "@frontend/lyng/comms/ChatWrapper";
import {
  Chat as LyngChat,
  ChatHeader as LyngChatHeader,
} from "@frontend/lyng/comms/V2";
import { ChatWrapperContext } from "./ChatWrapper";
import { useCareContext } from "../../providers";

const Loading = () => (
  <div className="flex justify-center dark:bg-greyscale-900 m-4">
    <LoadingBounce size="m" />
  </div>
);

const ChatHeader = ({
  chatClient,
  channelId,
}: {
  chatClient: StreamChat<DefaultGenerics>;
  channelId: string;
}) => {
  const { t } = useTranslate();
  const { userDict, fetchUsers } = useOutletContext<ChatWrapperContext>();

  const navigate = useNavigate();

  return (
    <div className="px-2 pt-8 pb-2 z-20 w-full bg-main">
      <div className="flex justify-start flex-row gap-2">
        <Button
          variant="secondary"
          onClick={() => {
            navigate("/chat");
            return;
          }}
          icon={BackIcon}
          iconPosition="only"
        />
        <LyngChatHeader
          client={chatClient}
          channelId={channelId}
          userDict={userDict}
          fetchUsers={fetchUsers}
          translationMap={{
            and: t("comms.and"),
          }}
        />
      </div>
    </div>
  );
};

export const Chat = () => {
  const { t } = useTranslate();
  const {
    state: { viewer },
  } = useCareContext();
  const { id } = useParams();
  const { chatClient } = useChatContext();
  const navigate = useNavigate();
  const ff_messaging = useFeatureFlag("Messaging");

  if (!ff_messaging) {
    navigate("/");
    return <Loading />;
  }

  if (!id || !chatClient) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col h-screen overflow-y-clip">
      <ChatHeader chatClient={chatClient} channelId={id} />
      <LyngChat
        client={chatClient}
        channelId={id}
        dateSettings={viewer?.tenantSettings}
        translationMap={{
          noChat: t("comms.nochat"),
          cancel: t("cancel"),
          save: t("save"),
          editMessage: t("comms.editMessage"),
        }}
      />
    </div>
  );
};
